<div class="modal-header">
  @if (isNewSignal) {
    <h4 class="modal-title" translate>New calculated signal</h4>
  }
  @if (!isNewSignal) {
    <h4 class="modal-title" translate>Edit calculated signal</h4>
  }
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form (ngSubmit)="onSave()" [formGroup]="signalForm">
  <div class="modal-body">
    <!-- NAME & LABEL-->
    <div class="row">
      <!--SIGNAL NAME-->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="signalName" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input (input)="signalNameChanged()"
            [ngClass]="{ 'is-invalid': f.signalName.errors }" class="form-control"
            formControlName="signalName"
            id="signalName"
            name="signalName"
            type="text">
            @if (f.signalName.errors) {
              <div class="invalid-feedback">
                @if (f.signalName.errors.required) {
                  <span translate> Signal name required</span>
                }
                @if (f.signalName.errors.pattern) {
                  <span translate>The signal name can only consist of latin letters, numbers and underscores.</span>
                }
              </div>
            }
            @if (signalNameUsed) {
              <span translate> Signal name already used!</span>
            }

          </div>
        </div>

        <!--SIGNAL LABEL-->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="signalLabel" translate>Label</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <input (change)="signalLabelChanged()" (focus)="signalLabelChanged()"
              [ngClass]="{ 'is-invalid': f.signalLabel.errors }" class="form-control"
              formControlName="signalLabel"
              id="signalLabel"
              name="signalLabel"
              type="text">
              @if (f.signalLabel.errors) {
                <div class="invalid-feedback">
                  @if (f.signalLabel.errors.required) {
                    <span translate> Signal label required</span>
                  }
                </div>
              }
              @if (signalLabelUsed) {
                <span translate> Signal label already used!</span>
              }
            </div>
          </div>
        </div>

        <div class="row">

          <!-- DECIMAL PLACES -->
          <div class="col-6 col-md-6 col-lg-3">
            <div class="form-group has-feedback">
              <label for="decimals"><span translate>Decimals</span></label>
              <input (change)="signalPrecisionChanged()" [ngClass]="{ 'is-invalid': f.decimals.errors }"
                class="form-control"
                formControlName="decimals"
                id="decimals"
                max="9" min="0"
                name="decimals"
                type="number">
                @if (f.decimals.errors) {
                  <div class="invalid-feedback">
                    @if (f.decimals.errors.min) {
                      <span translate>This value can't be negative!</span>
                    }
                    @if (f.decimals.errors.max) {
                      <span translate>A maximum of 9 decimal places can be entered</span>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- BQ & UNIT -->
            <div class="col-6 col-md-6 col-lg-3">
              <div class="form-group">
                <label for="unit"><span translate>Unit</span></label>
                <input (change)="signalUnitChanged()" class="form-control" formControlName="unit" id="unit" name="unit"
                  placeholder="E.g. %" type="text">
                </div>
              </div>

              <!-- SIGNAL COLOR-->
              <div class="col-6 col-md-6 col-lg-3">
                <scitis-color-picker (selectedColor)="onCloseColorPicker($event)"
                  [signalColor]="signal.signalColor">
                </scitis-color-picker>
              </div>

              <!-- STREAMING -->
              <div class="col-6 col-md-6 col-lg-3">
                <div class="form-group">
                  <label translate>Streaming</label>
                  <div class="custom-control custom-switch d-inline-flex">
                    <input (change)="streamToBigQueryChanged()" [checked]="signal.streamToBigQuery"
                      [disabled]="!isHigherThanAdmin" class="custom-control-input"
                      id="streamToBigQuery" name="streamToBigQuery"
                      type="checkbox">
                      <label class="custom-control-label" for="streamToBigQuery" translate>Stream to BigQuery</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="divider"></div>

              <!--FORMULA-->
              <div class="row">
                <div class="col-12">
                  <!-- Math function input -->
                  <div class="form-group">
                    <label for="formula" translate>Function editor</label>
                    <scitis-required-field-indicator></scitis-required-field-indicator>
                    <div [ngClass]="{'has-error': f.formula.errors, 'has-success': !f.formula.errors}"
                      class="input-group function-editor has-feedback">

                      <div class="input-group-prepend">
                        <span class="input-group-text"><em>fx</em></span>
                      </div>

                      <textarea (keyup)="formulaChanged()"
                        (click)="updateCursorPosition()"
                        class="form-control"
                        formControlName="formula"
                        id="formula" name="formula"
                      placeholder="${signal1} + ${signal2} + #{constant1}  ..." rows="3"></textarea>
                    </div>
                    @if (f.formula.errors) {
                      <div class="mt-2 text-danger">
                        @if (f.formula.errors.required) {
                          <span translate>Function missing</span>
                        }
                      </div>
                    }
                    <div class="d-flex align-items-center justify-content-center mb-3 mt-2 alert alert-info text-center">
                      <em class="fa-solid fa-circle-info mr-2"></em>
                      <span translate>Raw signal values are used for calculations. Signal scaling must be manually added in the editor.</span>
                    </div>
                  </div>
                  <div class="form">
                    <div class="form-group formula-editor-operators d-flex align-items-center">
                      <div class="btn-group me-2">
                        <button (click)="updateFormula('(')" [disabled]="!isHigherThanAdmin"
                          class="btn btn-outline-primary btn-sm" type='button'>
                          <strong>(</strong>
                        </button>
                        <button (click)="updateFormula(')')" [disabled]="!isHigherThanAdmin"
                          class="btn btn-outline-primary btn-sm" type='button'>
                          <strong>)</strong>
                        </button>
                      </div>
                      <div class="btn-group">
                        <button (click)="updateFormula('+')" [disabled]="!isHigherThanAdmin"
                          class="btn btn-outline-primary btn-sm" type='button'>
                          <i class="fa-solid fa-plus"></i>
                        </button>
                        <button (click)="updateFormula('-')" [disabled]="!isHigherThanAdmin"
                          class="btn btn-outline-primary btn-sm" type='button'>
                          <i class="fa-solid fa-minus"></i>
                        </button>
                        <button (click)="updateFormula('*')" [disabled]="!isHigherThanAdmin"
                          class="btn btn-outline-primary btn-sm" type='button'>
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                        <button (click)="updateFormula('/')" [disabled]="!isHigherThanAdmin"
                          class="btn btn-outline-primary btn-sm" type='button'>
                          <i class="fa-solid fa-divide"></i>
                        </button>
                      </div>
                      <div class="btn-group ms-auto">
                        <button (click)="clearAll()" [disabled]="!isHigherThanAdmin" class="btn btn-outline-primary btn-sm">
                          <i class="fa-solid fa-trash"></i>
                          <span translate>Clear function editor</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="divider"></div>

                  <div class="card mb-2">

                    <div class="card-body">

                      <div class="form-group mb-0">
                        <!-- Signal Selection -->
                        <div class="row">
                          <div class="col">
                            <ng-select #selectSignal (change)="onAddSelectedSignal($event)" [clearable]="false"
                              [items]="usableSignals"
                              [searchable]="true"
                              [searchFn]="searchSignal"
                              formControlName="signal"
                              id="signal"
                              [placeholder]="'Select signals' | translate">
                              <ng-template let-item="item" ng-label-tmp>
                                @if (isLoadingSignals) {
                                  <span class="fa-solid fa-spinner fa-spin"></span>
                                }
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <strong class="d-block">
                                  <span [innerHTML]="item.name"></span>
                                </strong>
                                <span class="d-block small text-muted" [innerHTML]="item.label | translate"></span>
                              </ng-template>
                            </ng-select>
                          </div>
                          <div class="col-auto">
                            <button (click)="collapseSignals.toggle()" [attr.aria-expanded]="!isSignalsCollapsed"
                              aria-controls="collapseExample"
                              class="btn btn-outline-primary"
                              type="button">
                              <span translate>Show selected</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div #collapseSignals="ngbCollapse" [(ngbCollapse)]="isSignalsCollapsed" class="mt-3">
                        <!-- Signals -->
                        @if (!signal.signals) {
                          <div class="alert alert-info">
                            <span translate>No signals added to function</span>
                          </div>
                        }
                        @if (signal.signals) {
                          <div class="scroll-view scroll-view-h1">
                            <table class="table vertical-align-middle table-sm table-hover">
                              <thead>
                                <tr>
                                  <th style="width: 50%;" translate>Signal</th>
                                  <th colspan="2" style="width: 50%;" translate>Name & Label</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (si of signal.signals; track si) {
                                  <tr (click)="onAddSelectedSignal(si)">
                                    <td>
                                      <b [innerText]="si.signal" [title]="si.signal"
                                      class="text-truncate d-inline-block" style="max-width: 320px"></b>
                                    </td>
                                    <td>
                                      <span [innerText]="si.name"></span><br/>
                                      <small [innerText]="si.label | translate" class="text-muted"></small>
                                    </td>
                                    <td class="text-right">
                                      <div aria-label="..." class="btn-group" role="group">
                                        <button (click)="onRemoveSignal(si)" class="btn btn-xs btn-outline-danger"
                                          [disabled]="!isHigherThanAdmin"
                                          [title]="'Remove signal' | translate"
                                          type="button"><span
                                        class="fa-solid fa-trash"></span></button>
                                      </div>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        }
                      </div>
                    </div>
                  </div>


                  <div class="card">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col">
                          <div class="form-group mb-0">
                            <!-- Constants Selection -->
                            <ng-select #selectConstant (change)="onAddSelectedTenantConstant($event)" [clearable]="false"
                              [items]="tenantConstants"
                              [searchable]="true"
                              bindLabel="name"
                              bindValue="id"
                              formControlName="tenantConstant"
                              id="tenantConstant"
                              [placeholder]="'Select constants' | translate">
                              <ng-template let-item="item" ng-label-tmp>
                                @if (isLoadingConstants) {
                                  <span class="fa-solid fa-spinner fa-spin"></span>
                                }
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-auto">
                          <button (click)="collapseConstants.toggle()" [attr.aria-expanded]="!isConstantsCollapsed"
                            aria-controls="collapseExample"
                            class="btn btn-outline-primary"
                            type="button">
                            <span translate>Show selected</span>
                          </button>
                        </div>
                      </div>
                      <!-- Constants -->
                      <div #collapseConstants="ngbCollapse" [(ngbCollapse)]="isConstantsCollapsed" class="mt-3">
                        @if (!signal.tenantConstants) {
                          <div class="alert alert-info">
                            <span translate>No constants added to function</span>
                          </div>
                        }
                        @if (signal.tenantConstants) {
                          <div class="scroll-view scroll-view-h1">
                            <table class="table vertical-align-middle table-sm table-hover">
                              <thead>
                                <tr>
                                  <th translate>Constant</th>
                                  <th colspan="2"><span translate>Value</span> & <span translate>Type</span></th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (tenantConst of signal.tenantConstants; track tenantConst) {
                                  <tr
                                    (click)="onAddSelectedTenantConstant(getNameForSettingId(tenantConst.settingId))">
                                    <td><b [innerText]="getNameForSettingId(tenantConst.settingId)"
                                      [title]="getNameForSettingId(tenantConst.settingId)"
                                      class="text-truncate d-inline-block"
                                    style="max-width: 320px"></b>
                                  </td>
                                  <td>
                                    <span [innerText]="getConstantActiveValue(tenantConst)"></span><br>
                                    <small [innerText]="getValueForSettingId(tenantConst.settingId)" class="text-muted"></small>
                                  </td>
                                  <td class="text-right">
                                    <div aria-label="..." class="btn-group" role="group">
                                      <button (click)="onRemoveConstant(tenantConst)" class="btn btn-xs btn-outline-danger"
                                        [disabled]="!isHigherThanAdmin"
                                        [title]="'Delete organization specific value' | translate"
                                        type="button"><span
                                      class="fa-solid fa-trash"></span></button>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <scitis-apply-to-machines-of-same-tag-warning
              [applyToMachinesOfSameTagMessage]="applyToMachinesOfSameTagMessage"
              [applyToMachinesOfSameTag]="applyToMachinesOfSameTag">

            </scitis-apply-to-machines-of-same-tag-warning>


          </div>

          <scitis-modal-footer
            (cancelButtonPressed)="onCancel()"
            (okButtonPressed)="onSave()"
            [cancelButtonText]="'Cancel'|translate"
            [disableOkButton]="isDisabledSaveBtn"
            [okButtonText]="'Save'|translate"
            [showRequiredFieldsIndicator]="true">

          </scitis-modal-footer>

        </form>
